import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import WifiMainImage from '../../assets/departureWifi/wifi_main.png';
import styled from 'styled-components';
import Step1 from '../../components/MedicalDepartureWifi/Step1';
import Step2 from '@/components/MedicalDepartureWifi/Step2';
import ImageCover from '@/components/MedicalDepartureWifi/ImageCover';
import { useHistory } from 'react-router-dom';
import MedicalKorDepartureStep1 from '../MedicalKorDepartureStep1';
import MedicalKorDepartureStep2 from '../MedicalKorDepartureStep2';

function MedicalDepartureWifi() {
  const history = useHistory();
  const step = new URL(window.location.href).searchParams.get('step');
  const place = (new URL(window.location.href).searchParams.get('place') ??
    'airport') as 'airport' | 'port';
  const isAndroid = !/Mac|iPhone|iPad/i.test(navigator.userAgent);

  const handleMoveToStep1 = () => {
    const currentUrl = new URL(window.location.href);
    history.push(`${currentUrl.pathname}${currentUrl.search}&step=1`);
  };

  return (
    <ReceiptLayout>
      <ImageCover img={WifiMainImage} />
      <Container>
        {step ? (
          step === '1' ? (
            <MedicalKorDepartureStep1 isAndroid={isAndroid} place={place} />
          ) : (
            <MedicalKorDepartureStep2 />
          )
        ) : (
          <>
            <StepWrapper>
              <Step1 isAndroid={isAndroid} place={place} />
              <Step2 />
            </StepWrapper>
            <Button onClick={handleMoveToStep1}>인증 시작하기</Button>
          </>
        )}
      </Container>
    </ReceiptLayout>
  );
}

const Container = styled.section`
  width: calc(100% + 40px);
  margin-top: 120px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 20px 20px 0 0;
  z-index: 10;
`;

const Button = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #246cf6;
  border-radius: 8px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  box-shadow: 0px 4px 12px 0px #1919192e;
  margin-top: 48px;
`;

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export default MedicalDepartureWifi;
